/* VM PDP-tweaks:
   1. Geen pagina-scroll bij het kiezen van een maat of kleur: de galerij mag
      alleen binnen zijn eigen container scrollen.
   NB: alles rond de Kiwi maattabel is hier bewust UIT gehaald (3-aug-2026,
   verzoek Joas). De maattabel wordt volledig door de Kiwi-app zelf geplaatst
   via het `kiwi_app` app-blok in de product-templates. Voeg hier geen
   verplaats-, verberg- of positioneerlogica voor Kiwi meer aan toe.
   NB2: betaaliconen (Conversion Bear) staan als app-blok in de product-template
   onder Buy buttons — daar komt geen JavaScript aan te pas. */
(function () {
  'use strict';

  /* Het thema roept scrollIntoView aan op galerij-media na een variantkeuze,
     wat de hele pagina omhoog trekt. Alleen voor media-items vangen we dat af
     en scrollen we uitsluitend de galerij-container zelf. */
  var origScrollIntoView = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function () {
    if (this.hasAttribute && this.hasAttribute('data-media-id')) {
      var vp = this.closest('[data-gallery-viewport]') || this.parentElement;
      if (vp) {
        if (vp.scrollWidth > vp.clientWidth + 1) {
          var links = this.getBoundingClientRect().left - vp.getBoundingClientRect().left + vp.scrollLeft;
          vp.scrollTo({ left: links - (vp.clientWidth - this.offsetWidth) / 2, behavior: 'smooth' });
        } else if (vp.scrollHeight > vp.clientHeight + 1) {
          var boven = this.getBoundingClientRect().top - vp.getBoundingClientRect().top + vp.scrollTop;
          vp.scrollTo({ top: boven, behavior: 'smooth' });
        }
      }
      return;
    }
    return origScrollIntoView.apply(this, arguments);
  };
})();
